<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link
              :to="{ name: 'CarbonReduction' }"
              tag="button"
              class="active"
            >
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="img-box">
            <img src="img/tree-card-03-1.png" alt="" />
            <div class="text-box">
              <h2>{{ $t("減碳量") }}</h2>
              <div class="text">
                <p>{{ $t("前一個月減碳量") }}</p>
                <p v-if="Day >= 15">
                  {{ CarbonReductionLastMonth }}KG
                </p>
                <p v-if="Day < 15">計算中</p>
              </div>
              <p>
                <span>配合各運具資料計算與收集，於每月15、25日更新</span>
              </p>
              <div class="text">
                <p>{{ $t("累積減碳量") }}</p>
                <p>{{ CarbonReductionTotal }}KG</p>
              </div>
              <p>
                {{ $t("自111年10月起搭乘計入減碳量。") }}
                <br />
                <span>{{ $t("自113年5月25日起改用環境部「淨零綠生活指引」運具排碳量計算。") }}</span>
              </p>
            </div>
            <!-- 新增圖片 -->
            <img src="img/tree-card-03-2.png" alt="" />
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    會員資料: "會員資料",
    我的套票: "我的套票",
    卡片資料: "卡片資料",
    套票兌換: "套票兌換",
    卡片交易記錄: "卡片交易記錄",
    錯誤: "錯誤",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次":
      "取得交易紀錄過程發生錯誤, 請稍後再試一次",
    確定: "確定",
    累積減碳量: "累積減碳量",
    自111年8月15日起搭乘記入減碳量: "自111年8月15日起搭乘記入減碳量",
    每月20號統計更新: "每月20號統計更新",
    減碳量: "減碳量",
    前一個月減碳量: "前一個月減碳量",
    減碳計算: "減碳計算",
    卡片交易紀錄: "卡片交易紀錄",
  },
  en: {
    會員資料: "Member info",
    我的套票: "My pass",
    卡片資料: "Card info",
    套票兌換: "Redeem pass",
    卡片交易記錄: "Card record",
    錯誤: "Error",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    確定: "Confirm",
    累積減碳量: "Accumulated",
    自111年8月15日起搭乘記入減碳量:
      "Rides count into carbon reduction starting 15th Aug 2022.",
    每月20號統計更新: "Statistics updates on the 20th of every month.",
    減碳量: "Carbon Reduced",
    前一個月減碳量: "Last month",
    減碳計算: "Carbon Reduction",
    卡片交易紀錄: "Activity",
  },
  jp: {
    會員資料: "マイページ",
    我的套票: "購入/予約履歴",
    卡片資料: "卡片資料",
    套票兌換: "チケット引き換え",
    卡片交易記錄: "卡片交易記錄",
    錯誤: "エラー",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次":
      "購入手続き中にエラーが発生しました,ご確認の上、再度お試しください",
    確定: "確定",
    累積減碳量: "累積減碳量",
    自111年8月15日起搭乘記入減碳量: "自111年8月15日起搭乘記入減碳量",
    每月20號統計更新: "每月20號統計更新",
    減碳量: "減碳量",
    前一個月減碳量: "前一個月減碳量",
    減碳計算: "減碳計算",
    卡片交易紀錄: "卡片交易紀錄",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "CarbonReduction",
  i18n,
  data() {
    return {
      CarbonReductionLastMonth: 0,
      CarbonReductionTotal: 0,
      IsLoaded: false,
      local: "zh_tw",
      Day: 0,
    };
  },
  created: function () {
    const today = new Date();
    this.Day = today.getDate();
    let that = this;
    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
          this.GLOBAL.subDirectory +
          "/Htmlv2/CarbonReduction",
        {
          params: {
            token: Storage.get("ek_login_token"),
          },
        }
      )
      .then((response) => {
        this.CarbonReductionLastMonth = response.data.CarbonReductionLastMonth;
        this.CarbonReductionTotal = response.data.CarbonReductionTotal;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-carbon");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CarbonReduction.vue